import { EpgQueryInfo } from '@shared/types/interfaces/query';

/******************/
/**     INFO     **/
/******************/

/**
 * Query related constants
 */
const DAYS_TO_LOAD = 7;

/**
 * @param channelIds Channel identifiers to fetch
 * @returns {EpgQueryInfo} Epg query info
 */
export default function info(channelIds: string[]): EpgQueryInfo {
  const date = new Date();
  date.setHours(date.getHours(), 0, 0, 0);
  const beginTime = date.toISOString();
  date.setDate(date.getDate() + DAYS_TO_LOAD);
  date.setHours(date.getHours(), 0, 0, 0);
  const endTime = date.toISOString();
  return {
    query: {
      beginTime,
      endTime,
      channelIds,
    },
  };
}
